import request from '../../http/request'
export const getUserList = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/user/search`, { params })
}
export const getUserAdd = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/user/new`, params)
}
export const userUpdate = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/user/update`, params)
}
export const getUserDelete = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/user/delete?${params}`)
}
export const getRoleList = params => {
  // 未使用
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/user/roleList`, { params })
}
export const getPlantDropDownList = () => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/user/getPlantDropDownList`)
}
